"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GuidelineSuggestionWidget = void 0;
var _react = _interopRequireWildcard(require("react"));
var _zod = require("zod");
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _field = require("@design/ui/field");
var _input = require("@design/ui/input");
var _select = require("@design/ui/select");
var _spinner = require("@design/ui/spinner");
var _textarea = require("@design/ui/textarea");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var guidelineSuggestionPlaybooksSchema = _zod.z.array(_zod.z.object({
  id: _zod.z.string(),
  name: _zod.z.string().nullable()
}));
var GuidelineSuggestionWidget = exports.GuidelineSuggestionWidget = function GuidelineSuggestionWidget(_ref) {
  var data = _ref.data,
    loadPlaybooks = _ref.loadPlaybooks,
    onLoadPlaybooksError = _ref.onLoadPlaybooksError,
    onSave = _ref.onSave,
    onDismiss = _ref.onDismiss;
  var _useState = (0, _react.useState)(data.name),
    _useState2 = _slicedToArray(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0, _react.useState)(data.description || ""),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = (0, _react.useState)(data.category),
    _useState6 = _slicedToArray(_useState5, 2),
    category = _useState6[0],
    setCategory = _useState6[1];
  var _useState7 = (0, _react.useState)(data.rule),
    _useState8 = _slicedToArray(_useState7, 2),
    rule = _useState8[0],
    setRule = _useState8[1];
  var _useState9 = (0, _react.useState)(data.comment || ""),
    _useState0 = _slicedToArray(_useState9, 2),
    comment = _useState0[0],
    setComment = _useState0[1];
  var _useState1 = (0, _react.useState)(data.importance || "Medium"),
    _useState10 = _slicedToArray(_useState1, 2),
    importance = _useState10[0],
    setImportance = _useState10[1];
  var _useState11 = (0, _react.useState)(data.playbook_id),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedPlaybookId = _useState12[0],
    setSelectedPlaybookId = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    playbooks = _useState14[0],
    setPlaybooks = _useState14[1];
  var _useState15 = (0, _react.useState)(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isLoading = _useState16[0],
    setIsLoading = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    error = _useState18[0],
    setError = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isSaving = _useState20[0],
    setIsSaving = _useState20[1];
  var fieldId = (0, _react.useId)();
  var loadPlaybooksRef = (0, _react.useRef)(loadPlaybooks);
  var onLoadPlaybooksErrorRef = (0, _react.useRef)(onLoadPlaybooksError);
  onLoadPlaybooksErrorRef.current = onLoadPlaybooksError;
  (0, _react.useEffect)(function () {
    var fetchPlaybooks = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _onLoadPlaybooksError, _t, _t2, _t3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _t = setPlaybooks;
              _t2 = guidelineSuggestionPlaybooksSchema;
              _context.n = 1;
              return loadPlaybooksRef.current();
            case 1:
              _t(_t2.parse.call(_t2, _context.v));
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t3 = _context.v;
              console.error("Failed to fetch playbooks:", _t3);
              setError("Failed to load playbooks");
              (_onLoadPlaybooksError = onLoadPlaybooksErrorRef.current) === null || _onLoadPlaybooksError === void 0 || _onLoadPlaybooksError.call(onLoadPlaybooksErrorRef, _t3);
            case 3:
              _context.p = 3;
              setIsLoading(false);
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function fetchPlaybooks() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchPlaybooks();
  }, []);
  var handleSave = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t4;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (name.trim()) {
              _context2.n = 1;
              break;
            }
            setError("Rule name is required");
            return _context2.a(2);
          case 1:
            if (category.trim()) {
              _context2.n = 2;
              break;
            }
            setError("Rule category is required");
            return _context2.a(2);
          case 2:
            if (rule.trim()) {
              _context2.n = 3;
              break;
            }
            setError("Guideline is required");
            return _context2.a(2);
          case 3:
            if (selectedPlaybookId) {
              _context2.n = 4;
              break;
            }
            setError("Please select a playbook");
            return _context2.a(2);
          case 4:
            setIsSaving(true);
            setError(null);
            _context2.p = 5;
            _context2.n = 6;
            return onSave(name.trim(), description.trim(), category.trim(), rule.trim(), comment.trim(), importance, selectedPlaybookId);
          case 6:
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t4 = _context2.v;
            setError("Failed to save rule");
          case 8:
            _context2.p = 8;
            setIsSaving(false);
            return _context2.f(8);
          case 9:
            return _context2.a(2);
        }
      }, _callee2, null, [[5, 7, 8, 9]]);
    }));
    return function handleSave() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: "my-2 max-w-full",
    "data-sentry-element": "Card",
    "data-sentry-component": "GuidelineSuggestionWidget",
    "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardTitle, {
        "data-sentry-element": "CardTitle",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex items-center gap-2",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.TaskIcon, {
            "data-sentry-element": "TaskIcon",
            "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
          }), "Guideline Rule Suggestion"]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-name"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Rule Name"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
          id: "".concat(fieldId, "-name"),
          value: name,
          onChange: function onChange(e) {
            return setName(e.target.value);
          },
          placeholder: "Enter a descriptive name for this rule",
          disabled: isSaving,
          "data-sentry-element": "Input",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-description"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Description (Optional)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
          id: "".concat(fieldId, "-description"),
          value: description,
          onChange: function onChange(e) {
            return setDescription(e.target.value);
          },
          placeholder: "Enter a brief description of what this rule does",
          disabled: isSaving,
          "data-sentry-element": "Textarea",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-category"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Rule Category"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
          id: "".concat(fieldId, "-category"),
          value: category,
          onChange: function onChange(e) {
            return setCategory(e.target.value);
          },
          placeholder: "Enter a category for this rule",
          disabled: isSaving,
          "data-sentry-element": "Input",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-rule"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Guideline"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
          id: "".concat(fieldId, "-rule"),
          value: rule,
          onChange: function onChange(e) {
            return setRule(e.target.value);
          },
          placeholder: "Describe what to look for and how to modify the document",
          disabled: isSaving,
          "data-sentry-element": "Textarea",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-comment"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Comment Template (Optional)"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
          id: "".concat(fieldId, "-comment"),
          value: comment,
          onChange: function onChange(e) {
            return setComment(e.target.value);
          },
          placeholder: "Template comment to leave for the counterparty",
          disabled: isSaving,
          "data-sentry-element": "Textarea",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-importance"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Risk Score"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
          value: importance,
          onValueChange: setImportance,
          disabled: isSaving,
          "data-sentry-element": "Select",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
            id: "".concat(fieldId, "-importance"),
            className: "w-full",
            "data-sentry-element": "SelectTrigger",
            "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
              "data-sentry-element": "SelectValue",
              "data-sentry-source-file": "GuidelineSuggestionWidget.tsx"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
            "data-sentry-element": "SelectContent",
            "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
            children: ["High", "Medium", "Low"].map(function (score) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                value: score,
                children: score
              }, score);
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-playbook"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Add to Playbook"
        }), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldDescription, {
          children: "Loading playbooks..."
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
          value: selectedPlaybookId || "",
          onValueChange: setSelectedPlaybookId,
          disabled: isSaving,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
            id: "".concat(fieldId, "-playbook"),
            className: "w-full",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
              placeholder: "Select a playbook..."
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
            children: playbooks.map(function (playbook) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
                value: playbook.id,
                children: playbook.name || "Untitled playbook"
              }, playbook.id);
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldError, {
        "data-sentry-element": "FieldError",
        "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
        children: error
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardFooter, {
      "data-sentry-element": "CardFooter",
      "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex w-full justify-end gap-2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "outline",
          size: "xs",
          onClick: onDismiss,
          disabled: isSaving,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: "Dismiss"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          size: "xs",
          onClick: handleSave,
          disabled: isLoading || isSaving,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "GuidelineSuggestionWidget.tsx",
          children: isSaving ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
              "data-icon": "inline-start"
            }), "Saving..."]
          }) : "Save Rule"
        })]
      })
    })]
  });
};